import { fetchIStatus } from '@/shared/fetchIStatus';

export const cancelInsurancePartnerEnrollment = async () => {
    return await fetchIStatus(
        '/api/patients/cancelinsurancepartnerenrollment',
        'post',
    );
};
